// payment conditions action types
export const SET_PAYMENTCONDITIONS_DATA = "SET_PAYMENTCONDITIONS_DATA";
export const ADD_PAYMENTCONDITION = "ADD_PAYMENTCONDITION";
export const UPDATE_PAYMENTCONDITION = "UPDATE_PAYMENTCONDITION";
export const DELETE_PAYMENTCONDITION = "DELETE_PAYMENTCONDITION";
